import { camelToTitleCase } from "@/services/stringUtility"

export const types = [
    "enum"
];

export function format(value) {
    return camelToTitleCase(value);
}
